import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import axiosInstance from "../../utils/axiosInstance";
import { truncateText } from "../../utils/Utils";
import {formatToLocalTime} from "../../utils/date";

const FileHistory = ({ fileId }) => {
  const [fileHistory, setFileHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axiosInstance.get(`/files/${fileId}/history`);
        setFileHistory(response.data);
      } finally {
        setLoading(false);
      }
    };

    fetchFiles();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="container mx-auto">
      <h2 className="text-2xl font-bold mb-6">File History</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full border-separate border-spacing-0 overflow-hidden rounded-[16px] border border-gray-200 bg-white text-sm dark:border-[#2c2c2e] dark:bg-[#1c1c1e]">
          <thead>
            <tr>
              <th className="border-b border-gray-200 bg-gray-100 px-4 py-3 text-left text-xs font-bold uppercase tracking-[0.08em] text-gray-500 dark:border-[#2c2c2e] dark:bg-[#161617] dark:text-slate-400">
                File Name
              </th>
              <th className="border-b border-gray-200 bg-gray-100 px-4 py-3 text-left text-xs font-bold uppercase tracking-[0.08em] text-gray-500 dark:border-[#2c2c2e] dark:bg-[#161617] dark:text-slate-400">
                Uploaded
              </th>
            </tr>
          </thead>
          <tbody>
            {fileHistory.map((file) => (
              <tr key={file.id} className="hover:bg-gray-100 dark:bg-[#161617]">
                <td
                  className="border-b border-gray-100 px-4 py-2.5 text-gray-700 dark:border-[#2c2c2e] dark:text-slate-300"
                  title={file.file_name}
                >
                  {truncateText(file.file_name, 30)}
                </td>
                <td className="border-b border-gray-100 px-4 py-2.5 text-gray-700 dark:border-[#2c2c2e] dark:text-slate-300">
                  {formatToLocalTime(file.created_at)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FileHistory;
